import React from 'react';

interface StreamingIndicatorProps {
  phase: 'rewriting' | 'searching' | 'generating';
}

const phaseText: Record<string, string> = {
  rewriting: 'Understanding your question...',
  searching: 'Searching documents...',
  generating: 'Generating response...',
};

const StreamingIndicator: React.FC<StreamingIndicatorProps> = ({ phase }) => {
  return (
    <div className="flex items-center space-x-2 text-gray-500 dark:text-gray-400">
      <div className="flex space-x-1">
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
      <span className="text-sm">{phaseText[phase] || 'Processing...'}</span>
    </div>
  );
};

export default StreamingIndicator;
